

import axios from 'axios'


class CCOApiConnector {

    constructor(){
        window.serverDirs={WS_PATH:"https://nafes.app/revision/revision-php/ws/"}
    }

    getCountries(callback) {
        axios({
            method: 'post',
            url: window.serverDirs.WS_PATH + 'cco/CcoWS.php?method=getCountries',


            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });
    }

    getStandard(countryId, callback) {

        axios({
            method: 'post',
            url: window.serverDirs.WS_PATH + 'cco/CcoWS.php?method=getStandard&countryId=' + countryId,


            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });

    }

    getStandardGrad(standardId, callback) {

        axios({
            method: 'post',
            url: window.serverDirs.WS_PATH + 'cco/CcoWS.php?method=getStandardGrad&standardId=' + standardId,


            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });

    }

    getGradSubjects(gradId, callback) {
        axios({
            method: 'post',
            url: window.serverDirs.WS_PATH + 'cco/CcoWS.php?method=getGradSubjects&gradId=' + gradId,


            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });
    }



    getSyllabus(subjectId, callback) {
        axios({
            method: 'post',
            url: window.serverDirs.WS_PATH + 'cco/CcoWS.php?method=getSyllabus&subjectId=' + subjectId,


            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });
    }


    getLearningOutcomes(topicIdsToGetLOs, callback) {

        axios({
            method: 'post',
            url: window.serverDirs.WS_PATH + 'cco/CcoWS.php?method=getLearningOutcomes&topicIdsToGetLOs=' + topicIdsToGetLOs,


            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });

    }



    getCognitiveList = (callback) => {

        axios({
            method: 'post',
            url: window.serverDirs.WS_PATH + 'quizBuilder/QuizWS.php?method=getCognitiveList',


            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });
    }

    getLOTitles = (LOIdsJson, callback) => {


        let formData = new FormData();
        formData.append("loIdsJson", JSON.stringify(LOIdsJson))


        axios({
            method: 'post',
            url: window.serverDirs.WS_PATH + 'cco/CcoWS.php?method=getLOTitles',
            data: formData,

            headers: {
                "Content-type": 'application/x-www-form-urlencoded'
            }

        }).then(function (response) {

            callback(response);
        })
            .catch(function (error) {
                console.log(error);
            });
    }
}

export default CCOApiConnector